<template>
  <p>
    <template v-for="child in children" :key="child.value">
      <a
        v-if="'href' in child"
        :href="child.href"
        @click="addMatomoEvent(child.value)"
        >{{ child.value }}</a
      >
      <template v-else>
        {{ child.value }}
      </template>
      <br v-if="child.newLine" />
    </template>
  </p>
</template>

<script lang="ts" setup>
import { computed } from "vue";

type Child = { href?: string; newLine?: boolean; value: string };

const props = defineProps<{ line: string | number }>();

const getLineBreakChildren = (line: string): Child[] => {
  return line
    .split("\n")
    .map((part, i, arr) => ({ value: part, newLine: i !== arr.length - 1 }));
};

const children = computed((): Child[] => {
  const children = [];
  let lastMatchEnd = 0;

  // Todo, maybe use a better url regex, this one is made up from my head
  const urlRegex =
    /(?:https?:\/\/([a-zA-Z0-9.\-+]+(?:\/[a-zA-Z0-9.%:_()+=-]*)*(?:\?[a-zA-Z0-9.%:_+&/()=-]*)?(?:#[a-zA-Z0-9.%:()_+=-]*)?)|tel:(\+?[\d ]+))/g;
  const line = props.line.toString(); // force string

  let match;

  // Loop through all links and create an anchor element for them
  /* eslint-disable */
  while ((match = urlRegex.exec(line))) {
    if (match.index - lastMatchEnd > 0) {
      children.push(...getLineBreakChildren(line.substring(lastMatchEnd, match.index)));
    }
    children.push({
      href: match[0],
      value: match[1] || match[2],
    });
    lastMatchEnd = urlRegex.lastIndex;
  }
  if (lastMatchEnd < line.length) {
    children.push(...getLineBreakChildren(line.substring(lastMatchEnd, line.length)));
  }

  return children;
});

const addMatomoEvent = (phoneNumber: string) => {
  (window.top as any)._paq?.push([
    "trackEvent",
    "Widget",
    "Click",
    "Phone number",
    phoneNumber,
  ]);
};
</script>
